import React, { useState } from "react"
import { Upload } from "@atos6/ui"
import { UploaderView } from "./UploaderView"
import { RcFile } from "antd/lib/upload"
import { HttpRequestHeader, UploadChangeParam } from "antd/lib/upload/interface"

// FIXME mover para @atos6/ui
type Props = {
  label: string
  action: string
  auth?: string
  headers?: HttpRequestHeader
  onComplete?: (e: UploadChangeParam) => void
  data?: { [key: string]: string }
  onSetUploadResolver?: (fn: Function) => void
  accept?: string
}

export function Uploader(props: Props) {
  const headers = props.auth ? { authorization: props.auth } : props.headers

  const [preview, setPreviewFile] = useState("")
  function beforeUpload(file: RcFile) {
    setPreviewFile(URL.createObjectURL(file))
    const promise = new Promise<never>(resolve => {
      props.onSetUploadResolver &&
        props.onSetUploadResolver(() => {
          resolve()
          return promise
        })
    })
    return promise
  }

  const [isLoading, setLoading] = useState(false)
  function onChange(e: UploadChangeParam) {
    setLoading(e.file.status === "uploading")
    if (e.file.status === "done" && props.onComplete) {
      props.onComplete(e)
    }
  }

  return (
    <Upload
      accept={props.accept}
      beforeUpload={beforeUpload}
      disabled={isLoading}
      onChange={onChange}
      headers={headers}
      name="file"
      action={props.action}
      data={props.data}
      showUploadList={false}>
      <UploaderView label={props.label} preview={preview} isLoading={isLoading} />
    </Upload>
  )
}
